import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Church, Heart, Mic, Calendar, Users } from 'lucide-react';

export const ServicesSection = () => {
  const services = [
    {
      icon: <Church className="w-8 h-8" />,
      title: "Choir Performances",
      description: "Professional gospel performances for churches, weddings, and special events",
      features: ["Wedding Ceremonies", "Church Services", "Special Events", "Corporate Functions"]
    },
    {
      icon: <Calendar className="w-8 h-8" />,
      title: "Church Event Bookings",
      description: "Complete event coordination and musical direction for church gatherings",
      features: ["Revival Services", "Concerts", "Workshops", "Community Events"]
    },
    {
      icon: <Mic className="w-8 h-8" />,
      title: "Vocal Coaching with Nadja Scott",
      description: "One-on-one professional vocal training and spiritual music education with Head Choirmaster Nadja Scott",
      features: ["Vocal Technique", "Song Interpretation", "Stage Presence", "Spiritual Growth"]
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Vocal Choir Intensive with Nadja Scott",
      description: "Comprehensive group training program for choirs seeking to elevate their musical excellence",
      features: ["Harmony Training", "Choir Dynamics", "Performance Skills", "Worship Leadership"]
    },
    {
      icon: <Heart className="w-8 h-8" />,
      title: "Artist and Ministry Development",
      description: "Complete development program for aspiring gospel artists and ministry leaders",
      features: ["Career Guidance", "Ministry Coaching", "Industry Connections", "Professional Development"]
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="container mx-auto px-6">
        {/* Services Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Our Services
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            From professional performances to personal development, we offer comprehensive gospel music services for every need
          </p>
        </div>

        {/* Main Services */}
        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {services.map((service, index) => (
            <Card key={index} className="bg-black border-2 border-red-600 hover:shadow-2xl hover:border-red-400 transition-all">
              <CardHeader className="text-center">
                <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4 text-white">
                  {service.icon}
                </div>
                <CardTitle className="text-xl font-bold text-white mb-3">{service.title}</CardTitle>
                <CardDescription className="text-gray-300">{service.description}</CardDescription>
              </CardHeader>
              <CardContent>
                <ul className="space-y-3">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-300">
                      <Heart className="w-4 h-4 text-red-600 mr-2 flex-shrink-0" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <h3 className="text-3xl font-bold text-white mb-4">
            Ready to Book Your Experience?
          </h3>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
            Let us bring the power of gospel music to your special occasion. Contact us today to discuss your needs.
          </p>
          <a 
            href="https://docs.google.com/forms/d/12hphFMKBt-Zd44mV26mRSBOZkxx0veNAx_E3yN2YRw8/viewform"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-full text-lg">
              Connect with Us!
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};